import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import './index.css';
import './global.css';
import App from './app';
import { initOpenTelemetry } from './services/telemetry';
import { LoadingScreen } from './components/loading-screen';

// ----------------------------------------------------------------------

initOpenTelemetry();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Suspense fallback={<LoadingScreen style={{ minHeight: '100vh' }} />}>
        <App />
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);
